import { createAction } from 'redux-actions';
import LayoutType from '../const/layout_type';

const $ = require('jquery');

const CATEGORY_BAR_ON = 'CATEGORY_BAR_ON';
const CATEGORY_BAR_OFF = 'CATEGORY_BAR_OFF';

const CATEGORY_BAR = 'CATEGORY_BAR_HIDE';
const ADDRESS_BAR = 'ADDRESS_BAR_HIDE';
const NAV_BAR = 'NAV_BAR_HIDE';
const KIOSK_MODE = 'KIOSK_MODE';
const DPOS_MODE = 'DPOS_MODE';
const MAINBOARD_MODE = 'MAINBOARD_MODE';
const SELF_SERVICE_MODE = 'SELF_SERVICE_MODE';
const SET_KIOSK_MODE = 'SET_KIOSK_MODE';
const FLIP_LAYOUT = 'FLIP_LAYOUT';
const SET_LAYOUT_VIEW = 'SET_LAYOUT_VIEW';

export const setMode = createAction(SET_KIOSK_MODE, mode => mode);
export const hideCategoryBar = createAction(CATEGORY_BAR_OFF);
export const showCategoryBar = createAction(CATEGORY_BAR_ON);
export const setCatBar = createAction(CATEGORY_BAR, status => status);
export const setAddressBar = createAction(ADDRESS_BAR, status => status);
export const setNavBar = createAction(NAV_BAR, status => status);
// export const setKioskMode = createAction(KIOSK_MODE, status => status);
export const setDposMode = createAction(DPOS_MODE, status => status);
export const setMainBoardMode = createAction(MAINBOARD_MODE, status => status);
export const setSelfServiceMode = createAction(SELF_SERVICE_MODE, status => status);
export const flipLayout = createAction(FLIP_LAYOUT);
export const setLayoutView = createAction(SET_LAYOUT_VIEW, layout => layout);

const initialState = {
  isNavBarHidden: false,
  isCategoryHidden: false,
  isAddressHidden: false,
  pos: 0,
  scrollDirection: 'up',
  navBarTitle: 'CHOOSE ITEM',
  env: '',
  posToTypeMap: {},
  displayingCatName: '',
  isKioskMode: false,
  kioskMode: '',
  layoutType: LayoutType.DEFAULT_GRID,
};

const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_SCROLL_TOP': {
      /* save vert scroll position */
      state = { ...state, pos: action.payload };
      break;
    }
    case 'CATEGORY_POSITION_SET': {
      const _posToTypeMap = { ...state.posToTypeMap };
      _posToTypeMap[action.payload.position] = action.payload.name;
      state = { ...state, posToTypeMap: _posToTypeMap };
      break;
    }
    case 'RESET_SCROLL_TOP': {
      /* restore vert scroll position */
      // document.body.scrollTop = action.payload;
      setTimeout(() => $(window).scrollTop(action.payload), 100);
      break;
    }
    case 'FILTERBAR_OPEN': {
      state = { ...state, isFilterBarOpen: true };
      break;
    }
    case 'FILTERBAR_CLOSE': {
      state = { ...state, isFilterBarOpen: false };
      break;
    }
    case 'SCROLL_DOWN': {
      state = { ...state, scrollDirection: 'down' };
      break;
    }
    case 'SCROLL_UP': {
      state = { ...state, scrollDirection: 'up' };
      break;
    }
    case 'NAV_BAR_TITLE_SET': {
      state = { ...state, navBarTitle: action.payload };
      break;
    }
    case 'ENV_SET': {
      state = { ...state, env: action.payload };
      break;
    }
    case 'CATEGORY_DISPLAYING_SET': {
      state = { ...state, displayingCatName: action.payload };
      break;
    }
    case CATEGORY_BAR_OFF: {
      state = { ...state, categoryBar: false };
      break;
    }
    case CATEGORY_BAR_ON: {
      state = { ...state, categoryBar: true };
      break;
    }
    case CATEGORY_BAR: {
      state = { ...state, isCategoryHidden: action.payload };
      break;
    }
    case ADDRESS_BAR: {
      state = { ...state, isAddressHidden: action.payload };
      break;
    }
    case NAV_BAR: {
      state = { ...state, isNavBarHidden: action.payload };
      break;
    }
    case KIOSK_MODE: {
      state = { ...state, isKioskMode: action.payload };
      break;
    }
    case SET_KIOSK_MODE: {
      state = { ...state, kioskMode: action.payload.kioskMode, isKioskMode: action.payload.isKioskMode };
      break;
    }
    case FLIP_LAYOUT: {
      state = { ...state, layoutType: state.layoutType === LayoutType.GRID ? LayoutType.LIST : LayoutType.GRID };
      break;
    }
    case SET_LAYOUT_VIEW: {
      state = { ...state, layoutType: state.layoutType.indexOf('DEFAULT') > -1 ? action.payload : state.layoutType };
      break;
    }
    default: {
      break;
    }
  }
  return state;
};

export function getType(state, curPos) {
  const { posToTypeMap } = state;
  let type = '';
  const keys = Object.keys(posToTypeMap);
  for (let i = 0; i < keys.length; i++) {
    if (i === 0 && curPos < keys[i]) {
      type = posToTypeMap[keys[i]];
      return type;
    }
    if (i === keys.length - 1 && curPos > keys[i]) {
      type = posToTypeMap[keys[i]];
      return type;
    }
    if (curPos > keys[i] && curPos < keys[i + 1]) {
      type = posToTypeMap[keys[i]];
      return type;
    }
  }
  return type;
}

export default viewReducer;



// WEBPACK FOOTER //
// ./src/reducers/viewReducer.js